import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../utils/urls';
import { Observable } from 'rxjs';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';

@Injectable({
    providedIn: 'root'
})

export class LanguageDataService {
    constructor(private dataProvider: DataService) {
    }

    getLocalizationData(languageCode: string): Observable<any> {
        return this.dataProvider.GetNonEnc(Urls.GetLocalization, Application[Application.Widget], languageCode);
    }
}